import { ESuggestType } from '@cian/geosuggest-widget';
import { IGeoValue } from '../../types/filters/user_geo';
import { GEO_OBJECT_TYPES_MAP } from '../../constants/filters/geo/geoObjectTypesMap';

export interface ISuggestGeoItem {
  group:
    | ESuggestType.city
    | ESuggestType.district
    | ESuggestType.newbuilding
    | ESuggestType.railway
    | ESuggestType.road
    | ESuggestType.underground
    | ESuggestType.village;
  id: number;
}

export function normalizeGeoObject(geoObject: ISuggestGeoItem): IGeoValue {
  return {
    type: GEO_OBJECT_TYPES_MAP[geoObject.group],
    id: geoObject.id,
  } as IGeoValue;
}
